import { useController } from 'react-hook-form';

import styles from './pills-selector.module.scss';
export const PillsSelector = ({
  name,
  control,
  options,
  required = false,
  maxSelections = null,
}) => {
  const { field } = useController({
    name,
    control,
    rules: { required: required ? `${name} is required` : false },
    defaultValue: [],
  });

  const selectedValues = Array.isArray(field.value) ? field.value : [];

  const toggleSelection = (value) => {
    const newSelection = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : maxSelections && selectedValues.length >= maxSelections
      ? selectedValues
      : [...selectedValues, value];

    field.onChange(newSelection);
  };

  return (
    <div>
      <div className={styles['pills-container']}>
        {options.map((option) => (
          <button
            className={styles['pill']}
            key={option.value}
            type="button"
            data-selected={selectedValues.includes(option.value)}
            onClick={() => toggleSelection(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
